<template>
  <app-section-wrap :modifier="'login --terms'">
    <div class="card" column="xs-12 s-12 m-8 +m-2">
       <div>
          <h1>Thank you for visiting EyeMed Client Portal. Your session has ended.</h1>
        </div>
    </div>
  </app-section-wrap>
</template>
<script>
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import logouttable from '@mixins/logouttable'

  export default {
    mixins: [logouttable],
    components: {
      AppSectionWrap
    },
    beforeCreate () {
      this.$store.dispatch('cacheBuster/NUKE_STATE')
    }
  }
</script>
